import React, {useState, useEffect, useContext} from 'react';
import useKeyPress from '../../../hooks/useKeyPress';
import FullBodyMenuView from '../../views/fullBodyMenuView';
import {volumeUnitItem} from '../../../App';
import MassUnit from './mass-unit';
import DensityUnit from './density-unit';
import MenuContext from '../../../context/menuContext';
import ConfigContext from '../../../context/configContext';

function VolumeUnit() {
  const {onComponent, setDisableMenu} = useContext(MenuContext);
  const {config, onUpdate} = useContext(ConfigContext);
  const leftPress = useKeyPress('ArrowLeft');

  useEffect(() => {
    if (!leftPress) return;

    onComponent(<MassUnit />);
  }, [leftPress]);

  const onRight = selected => {
    onUpdate('volFlowRate', {...config.volFlowRate, unit: selected.name});
    // setDisableMenu(false);
    onComponent(<DensityUnit />);
  };

  return (
    <FullBodyMenuView
      title="Select Volume Flow Unit"
      menuItems={volumeUnitItem}
      initialSelected={config.volFlowRate.unit}
      onRightCallback={onRight}
    />
  );
}
export default VolumeUnit;
